<template>
	<NoLineBreaks>
		<div v-if="baseStation.mntpnt_int && baseStation.mntpnt_src">
			<span v-if="directionLTR">{{ baseStation.mntpnt_src }} &rarr; {{ baseStation.mntpnt_int }}</span>
			<span v-else>{{ baseStation.mntpnt_int }} &larr; {{ baseStation.mntpnt_src }}</span>
		</div>
		<div v-else-if="baseStation.mntpnt_int">{{ baseStation.mntpnt_int }}</div>
		<div v-else-if="baseStation.mntpnt_src">{{ baseStation.mntpnt_src }}</div>
		<div v-else>{{ $t('base-stations.mountpointHidden') }}</div>
	</NoLineBreaks>
</template>

<script>
import NoLineBreaks from '@/components/common/NoLineBreaks';
import { useLocaleData } from '@/locales/useLocaleData';

export default {
	components: {
		NoLineBreaks,
	},
	props: ['baseStation'],
	setup() {
		const { directionLTR } = useLocaleData();
		return {
			directionLTR,
		}
	},
}
</script>
